import styled from '@emotion/styled';

import { HoverDropDown } from '../../components/DropDown/HoverDropDown';
import SharpChevronDownIcon from '../../components/Icons/SharpChevronDownIcon';
import { InternalNavLink } from '../../components/Link/Link';
import { INavConfig, navConfig } from '../navConfig';

const Nav = () => {
 return (
  <StyledNav>
   {navConfig.map((nav: INavConfig, index) => {
    return nav.dropDownItems ? (
     <HoverDropDown
      key={index}
      // posLeft='-180px'
      label={
       <>
        {nav.title}
        <SharpChevronDownIcon />
       </>
      }
     >
      <BoundingBox>
       <DropDownContent>
        {nav.dropDownItems.map(({ link, label, description }, index) => (
         <InternalNavLink to={link} key={index}>
          <DropDownCell>
           <TextLabel>
            <LabelCell>{label}</LabelCell>
            <DescriptionsCell>{description}</DescriptionsCell>
           </TextLabel>
          </DropDownCell>
         </InternalNavLink>
        ))}
       </DropDownContent>
      </BoundingBox>
     </HoverDropDown>
    ) : // end dropdown menu
    nav.title === 'Bonded Terminals' ? (
     <BoundedTerminals>
      <InternalNavLink to={nav?.path ?? ''} key={nav.title}>
       {nav.title}
      </InternalNavLink>
     </BoundedTerminals>
    ) : (
     <InternalNavLink to={nav?.path ?? ''} key={nav.title}>
      {nav.title}
     </InternalNavLink>
    );
   })}
  </StyledNav>
 );
};

export default Nav;

const StyledNav = styled.div`
 display: flex;
 align-items: center;
 gap: 2rem;
 font-weight: 400;

 & > * {
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
 }

 @media (max-width: 884px) {
  display: none;
 }
`;

const BoundingBox = styled.div`
 padding-top: 42px;
`;

const DropDownContent = styled.div`
 display: grid;
 grid-template-columns: 1fr;
 width: fit-content;
 padding: 20px;
 gap: 16px;

 box-shadow: 0px 16px 30px 0px rgba(0, 0, 0, 0.1),
  0px 0px 1px 0px rgba(0, 0, 0, 0.25);

 overflow: hidden;
 border-radius: 10px;
 background-color: white;
`;

const DropDownCell = styled.div`
 padding: 8px;
 display: grid;
 gap: 16px;
 align-items: center;
 grid-template-columns:1fr;
 width: fit-content;
 border-radius: 5px;

 &:hover {
  background-color: #fef5f7;
 }
`;

const TextLabel = styled.div`
 display: flex;
 flex-direction: column;
 gap: 4px;
`;

const LabelCell = styled.div`
 color: ${({ theme }) => theme.palette.redFontColor};
 font-weight: 700;
 line-height: 19.2px;
`;

const DescriptionsCell = styled.div`
 display: flex;
 line-height: 12px;
 font-size: 12px;
 font-weight: 400;
 color: #71748c;
`;

const BoundedTerminals = styled.div`
 display: flex;
 border-left: 1px solid ${({ theme }) => theme.palette.borderColor};
 padding-left: 25px;

 & > * {
  color: ${({ theme }) => theme.palette.redFontColor};
 }
`;
